import React, { useRef, useState } from "react";
import {
  AddIconBlue,
  Arrowlinkicon,
  coachDemoImg,
  TrashIconGray,
  UserFallback,
  UserIconRed,
} from "../../../../constant/imagePath";
import classes from "./PersonalInfoMobile.module.css";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import { Button } from "../../../../stories/Button/Button";
import { Col, Row } from "react-bootstrap";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import { Input } from "../../../../stories/Input/Input";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import DisableAccountModal from "../../../../components/Modals/CoachFlow/Settings/DisableAccount/DisableAccount";
import EditPhotoModal from "../../../../components/Modals/CoachFlow/OnBoarding/EditPhoto/EditPhoto";
import MobileEditPhotoModal from "../../../../components/Modals/CoachFlow/OnBoarding/MobileEditPhotoModal/MobileEditPhotoModal";

const PersonalInfoMobile = () => {
  const coverRef = useRef(null);
  const [coverPhoto, setCoverPhoto] = useState(coachDemoImg);
  const [isEditingCover, setIsEditingCover] = useState(false);

  const [fullName, setFullName] = useState("Hanna Specter");
  const [phoneNumber, setPhoneNumber] = useState("+16102458015");
  const [gender, setGender] = useState({ label: "Male", value: "Male" });
  const [dateOfBirth, setDateOfBirth] = useState("22/04/1992");
  const [email, setEmail] = useState("john.johnson@gmail.com");
  const [aboutMe, setAboutMe] = useState("");

  const [sportsType, setSportsType] = useState();
  const [experienceLevel, setERxperienceLevel] = useState();

  const [password, setPassword] = useState();
  const [newpassword, setNewPassword] = useState();
  const [confirmpassword, setConfirmPassword] = useState();

  const [disableModal, setDisableModal] = useState(false);

  const addCoverPhoto = () => {
    coverRef.current.click();
  };

  const deleteCoverPhoto = () => {
    setCoverPhoto("");
  };
  return (
    <div>
      <div className={[classes.editPhotoMainDiv]}>
        <div className={classes.imageUpdated}>
          <img src={coverPhoto} onError={(e) => {
            e.target.onerror = null
            e.target.src = UserFallback
          }
          } />
        </div>

        <div className={classes.editPhotoInnerDiv}>
          <h5
            style={{
              color: Colors.neutralShadesOfNero,
              ...Fonts.h5,
              fontSize: "19px",
              lineHeight: "24px",
            }}
          >
            Add your profile pic
          </h5>
          <p
            style={{
              color: Colors.neutralShadesOfDimGray,
              ...Fonts.p1,
              fontSize: "14px",
              lineHeight: "24px",
            }}
          >
            Upload PNG or JPEG file. File size limit is up to 5MB
          </p>
        </div>
      </div>
      <Row className={[classes.btnRow]}>
        <Col xs={9} sm={10} md={11}>
          <Button
            onClick={addCoverPhoto}
            primary={true}
            label="Upload new picture"
            customStyle={{
              marginRight: "10px",
              width: "100%",
              padding: "0px",
              ...Fonts.b2,
            }}
          />
        </Col>
        <Col xs={3} sm={2} md={1}>
          <Button
            icon={TrashIconGray}
            onClick={deleteCoverPhoto}
            primary={false}
            customStyle={{
              border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              width: "100%",
            }}
          />
        </Col>
      </Row>

      <input
        className="d-none"
        accept="image/*"
        type={"file"}
        ref={coverRef}
        onChange={(e) => {
          console.log("aaa");
          setCoverPhoto(e.target.files[0]);
          setIsEditingCover(true);
        }}
        onClick={(event) => {
          event.target.value = null;
        }}
      />

      <Row>
        <Col xs={12} className={[classes.formCol]}>
          <Input
            label="Full Name"
            state={fullName}
            setter={setFullName}
            placeholder=""
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <Input
            label="Phone Number (Optional)"
            state={phoneNumber}
            setter={setPhoneNumber}
            placeholder=""
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <DropDown
            label="Gender"
            state={gender}
            setter={setGender}
            options={[
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
              { label: "Other", value: "Other" },
            ]}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <Input
            type="date"
            label="Date Of Birth"
            state={dateOfBirth}
            setter={setDateOfBirth}
            placeholder=""
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <DropDown
            label="Sport type"
            state={sportsType}
            setter={setSportsType}
            placeholder="Sport type"
            options={[
              { label: "Tennis", value: "Tennis" },
              { label: "Basketball", value: "Basketball" },
              { label: "Football", value: "Football" },
            ]}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <DropDown
            // label="Experience level"
            placeholder="Experience"
            state={experienceLevel}
            setter={setERxperienceLevel}
            options={[
              { label: "Beginner", value: "Beginner" },
              { label: "Intermediate", value: "Intermediate" },
              { label: "Competitor", value: "Competitor" },
            ]}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <LinkButtonWithIcon
            customStyle={{
              ...Fonts.b2,
              fontSize: "14px",
              lineHeight: "20px",
              border: "none",
              marginBottom: "0px",
            }}
            primary={true}
            text="Add experience"
            leftIcon={AddIconBlue}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <TextArea
            label="About me"
            state={aboutMe}
            setter={setAboutMe}
            placeholder="Drop a few sentences about yourself..."
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <Button
            primary={true}
            disabled={true}
            label="Save changes"
            customStyle={{
              width: "133px",
              padding: "0px",
              ...Fonts.b2,
              marginBottom: "16px",
            }}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <h5
            style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
            className={`${classes.mb24}`}
          >
            Privacy settings
          </h5>
          <Input
            type="password"
            state={password}
            setter={setPassword}
            label="Current password"
            placeholder={"Enter current password"}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <Input
            type="password"
            state={newpassword}
            setter={setNewPassword}
            label="New password"
            placeholder={"Enter new password"}
          />
        </Col>

        <Col xs={12} className={[classes.formCol]}>
          <Input
            type="password"
            state={confirmpassword}
            setter={setConfirmPassword}
            label="Confirm New password"
            placeholder={"Re-enter new password"}
          />
        </Col>
        <Col
          xs={12}
          className={[classes.formCol, classes.pb24]}
          style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        >
          <Row>
            <Col xs={6}>
              <Button
                primary={false}
                customStyle={{
                  width: "100%",
                  padding: "0",
                  marginRight: "16px",
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                primary={true}
                customStyle={{ width: "100%", padding: "0" }}
              >
                Save changes
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
            Can't remember your current password?
          </p>
          <LinkButtonWithIcon
            rightIcon={Arrowlinkicon}
            text="Reset password via email"
            primary={true}
            customStyle={{
              ...Fonts.p1,
              fontSize: "16px",
              lineHeight: "16px",
              marginBottom: "24px",
            }}
          />
        </Col>
        <Col xs={12} className={[classes.formCol]}>
          <h4
            style={{
              ...Fonts.h4,
              color: Colors.neutralShadesOfNero,
              fontSize: "20px",
              lineHeight: "28px",
            }}
            className={`${classes.mb12}`}
          >
            Disable account
          </h4>
          <p
            style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            className={[classes.mb24].join(" ")}
          >
            <span style={{ color: Colors.errorColor, ...Fonts.h7 }}>
              PLEASE NOTE!
            </span>{" "}
            This means your account will be hidden until you reactivate it by
            logging back in.
          </p>
          <div className={[classes.disablebtnwidth].join(" ")}>
            <Button
              primary={false}
              onClick={() => setDisableModal(!disableModal)}
              customStyle={{ width: "100%" }}
            >
              Disable the account
            </Button>
          </div>
        </Col>
      </Row>
      {/* Edit Photo Modal */}
      {isEditingCover && (
        <MobileEditPhotoModal
          show={isEditingCover}
          setShow={setIsEditingCover}
          state={coverPhoto}
          onSave={setCoverPhoto}
        />
      )}

      {/* <DisableAccountModal show={disableModal} setShow={setDisableModal} /> */}
    </div>
  );
};

export default PersonalInfoMobile;
